import Vue from 'vue';
import VueI18n from 'vue-i18n';
import config from '@/__config'

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context('@/__vue2stone/lang', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}
function getLocale() {
  const language = (
    navigator.language || navigator.browserLanguage
  ).toLowerCase();
  let tar_locale = '';
  tar_locale = language ? language : 'tw';
  return tar_locale;
}

const configLang = config ? config.locale.lang : null

export default new VueI18n({
  locale: getLocale() || configLang || 'tw',
  fallbackLocale: configLang || 'tw',
  messages: loadLocaleMessages(),
  silentTranslationWarn: true
});
